import reducers from './dist/reducers';

export default reducers;
export * from './dist/reducers';
